import { $lang, getTagFromNode, useTranslation } from '@msdk/common'
import {
  ControlValidationType,
  FormFieldDefinition,
  FormOpenMode,
  TimeFieldDefinition,
  TimeValue,
} from '@msdk/definitions'
import { FormField, TimePicker } from '@msdk/ui'
import React from 'react'
import { useParams } from 'react-router-dom'
import { useRecoilValue } from 'recoil'

import { useFieldLabel, useFieldSeverity, useFieldValue, useHasMandatoryValidation } from '../../../hooks'
import { FieldProps } from '../../../models/form'
import { nodeHasFlag } from '../../../utils'
import { ValidationMessages } from '../../ValidationMessages'

export function TimeField({ node, onChange, fieldArgs }: FieldProps) {
  const fieldDef = node.value.fieldDefinition as TimeFieldDefinition
  const formDef = node.value.formDefinition as FormFieldDefinition
  const fieldLabel = useFieldLabel(fieldDef, formDef)
  const t = useTranslation()
  const { moduleName } = useParams()
  const [value, setValue] = useFieldValue(node, onChange)
  const locale = useRecoilValue($lang)

  const hasMandatoryFlag = nodeHasFlag(node, ControlValidationType.Mandatory)
  const hasMandatory = useHasMandatoryValidation(node, fieldDef.entityName)

  const onFieldChange = (e: any) => {
    const newValue = e
    const fieldValue = newValue !== '' ? new TimeValue(newValue) : null
    node.value.isDirty = true
    setValue(fieldValue)
  }

  const isReadOnly = node.value.state === 'Readonly'
  const severity = useFieldSeverity(fieldDef, node)

  return (
    <FormField
      $hasPrefix={!!fieldDef.prefixIcon}
      required={(hasMandatory || hasMandatoryFlag) && fieldArgs?.formOpenMode !== FormOpenMode.Readonly}
      size="small"
      data-test-id={getTagFromNode(fieldDef, moduleName)}
      severity={severity}
      readOnly={isReadOnly}
      disabled={isReadOnly}
    >
      <TimePicker
        label={fieldArgs?.showLabel && fieldLabel}
        disabled={isReadOnly}
        onChange={onFieldChange}
        locale={locale}
        value={value?.value}
        slotProps={{
          textField: {
            size: 'small',
            required: (hasMandatory || hasMandatoryFlag) && fieldArgs?.formOpenMode !== FormOpenMode.Readonly,
          },
        }}
      />
      <ValidationMessages messages={node.value.validationMessages} fieldDef={fieldDef} node={node} />
    </FormField>
  )
}
